export default __webpack_public_path__ + "static/media/image2pro4.cb9731a8.jpeg";